import api from './client';


// Returns server side config values used by various components 
// for conditional rendering.
const getConfig = async () => {
  const res = await api.get('/config')
  return res.data;
};

const config = { getConfig }
export default config;
